import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalLanguagePage } from './modal-language.page';

const routes: Routes = [
  {
    path: '',
    component: ModalLanguagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalLanguagePageRoutingModule {}
